document.addEventListener('DOMContentLoaded', function () {
  const loadMoreBtn = document.getElementById('load-more');
  const productGrid = document.getElementById('product-grid');

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function () {
      const currentPage = parseInt(this.getAttribute('data-page'));
      const totalPages = parseInt(this.getAttribute('data-pages'));

      const url = window.location.pathname + `?page=${currentPage}&view=ajax`;

      fetch(url)
        .then(res => res.text())
        .then(data => {
          const parser = new DOMParser();
          const htmlDoc = parser.parseFromString(data, 'text/html');
          const newProducts = htmlDoc.querySelectorAll('#product-grid .grid__item');

          newProducts.forEach(item => {
            productGrid.appendChild(item);
          });

          if (currentPage >= totalPages) {
            loadMoreBtn.style.display = 'none';
          } else {
            loadMoreBtn.setAttribute('data-page', currentPage + 1);
          }
        })
        .catch(err => console.error('Error loading more products:', err));
    });
  }
});